<template>
  <v-card elevation="0">
    <v-row no-gutters align="center">
      <v-col cols="12" sm="6">
        <v-row
          no-gutters
          class="text-body-2 default--text text--darken-2 font-weight-bold my-5"
        >
          <v-col cols="6" md="3">
            <span>{{ $t("orders.header.orderNumber") }}</span>
          </v-col>
          <v-col cols="6" md="3">
            <span>{{ $t("orders.header.status") }}</span>
          </v-col>
          <v-col cols="12" md="6"> </v-col>
        </v-row>
        <v-row no-gutters class="text-body-1 font-weight-bold my-5">
          <v-col cols="6" md="3">
            <span class="primary--text">#{{ order.orderId }}</span>
          </v-col>
          <v-col cols="6" md="3">
            <OrderStatusBadge v-bind:order="order" class="default--text" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" class="actions d-flex justify-end">
        <v-col
          cols="12"
          md="6"
          class="d-flex justify-center justify-sm-end pa-0 align-center mt-5"
        >
          <OrderQrCode
            v-if="order.orderInfos.PIN_CODE"
            :codeValue="order.orderInfos.PIN_CODE"
            :width="40"
            :height="40"
          />

          <div
            class="d-flex flex-column justify-center align-center mr-5"
            v-if="order.isEditable"
          >
            <v-btn
              @click.stop.prevent="editOrder(order.orderId)"
              :small="!$vuetify.breakpoint.xs"
              class="primary white--text"
              icon
              fab
            >
              <v-icon>$edit</v-icon>
            </v-btn>
            <span class="primary--text text-center small">{{
              $t("orders.button.edit")
            }}</span>
          </div>

          <div
            class="d-flex flex-column justify-center align-center mr-5"
            v-if="order.orderStatusId == 8"
          >
            <v-btn
              @click.stop.prevent="
                handleReceiptDownload(receiptUrl, order.orderId)
              "
              target="_blank"
              :href="receiptUrl"
              :small="!$vuetify.breakpoint.xs"
              class="primary white--text"
              icon
              fab
            >
              <v-icon>$receipt</v-icon>
            </v-btn>
            <span class="primary--text text-center small">{{
              $t("orders.button.receipt")
            }}</span>
          </div>

          <div
            class="d-flex flex-column justify-center align-center mr-5"
            v-if="order.isPayable"
          >
            <v-btn
              @click.stop.prevent="showPayment"
              :small="!$vuetify.breakpoint.xs"
              class="primary white--text"
              icon
              fab
            >
              <v-icon>$creditcard</v-icon>
            </v-btn>
            <span class="primary--text text-center small">{{
              $t("orders.button.retryPayment")
            }}</span>
          </div>

          <div class="d-flex flex-column justify-center align-center mr-5">
            <v-btn
              @click="printOrder"
              :small="!$vuetify.breakpoint.xs"
              class="primary white--text"
              icon
              fab
            >
              <v-icon>$print</v-icon>
            </v-btn>
            <span class="primary--text text-center small">Stampa</span>
          </div>
          <div
            class="d-flex flex-column justify-center align-center  ml-4"
            v-if="order.orderStatusId == 8 || order.orderStatusId == 10"
          >
            <v-btn
              @click.stop.prevent="addAllToCart(order.orderId)"
              :small="!$vuetify.breakpoint.xs"
              class="primary white--text"
              icon
              fab
              v-if="order.orderStatusId == 8 || order.orderStatusId == 10"
            >
              <v-icon>$cart</v-icon>
            </v-btn>
            <span class="primary--text text-center small">{{
              $t("orders.button.reorder")
            }}</span>
          </div>

          <div
            class="d-flex flex-column justify-center align-center"
            v-if="order.isDeletable"
          >
            <v-btn
              @click.stop.prevent="deleteOrder(order.orderId)"
              :small="!$vuetify.breakpoint.xs"
              class="promo--text"
              icon
              fab
            >
              <v-icon>$delete</v-icon>
            </v-btn>
            <span class="promo--text text-center small">{{
              $t("orders.button.delete")
            }}</span>
          </div>
        </v-col>
      </v-col>
    </v-row>
  </v-card>
</template>
<style scoped lang="scss">
.small {
  font-size: 10px;
  min-height: 16px;
  text-transform: uppercase;
}
</style>
<script>
import OrderStatusBadge from "@/components/orders/OrderStatusBadge";
import OrderQrCode from "./OrderQrCode";
import downloadDocumentMixin from "~/mixins/downloadDocument";
export default {
  name: "OrderDetailInfo",
  mixins: [downloadDocumentMixin],
  components: { OrderStatusBadge, OrderQrCode },
  props: ["order"],
  computed: {
    receiptUrl() {
      let documentTypeId = 12;
      let orderId = this.order.orderId;
      return `/ebsn/api/order/document?document_type_id=${documentTypeId}&type=pdf&order_id=${orderId}`;
    }
  },
  methods: {
    addAllToCart(orderId) {
      this.$emit("addAllToCart", {
        orderId
      });
    },
    deleteOrder(orderId) {
      this.$emit("deleteOrder", {
        orderId
      });
    },
    editOrder(orderId) {
      this.$emit("editOrder", {
        orderId
      });
    },
    printOrder() {
      if (this.isCordova) {
        window.cordova.plugins.printer.print();
      } else {
        window.print();
      }
    },
    showPayment() {
      this.$emit("showPayment");
    }
  }
};
</script>
